import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ErrorObject } from 'ajv';
import { Simulation } from './simulation.model';

export interface SimulationState extends EntityState<Simulation, number>, ActiveState<number> {
  resultMode: boolean;
  coverageMode: boolean;
  parametersErrors: ErrorObject[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'simulation' })
export class SimulationStore extends EntityStore<SimulationState> {

  constructor() {
    super({
      loading: false,
      resultMode: false,
      coverageMode: false,
      parametersErrors: []
    });
  }

}
